import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { bloodTypes } from 'presentation/model/constants';

class ExtraTabStudentForm extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        let { form, handleChange, component } = this.props;
        return (
            <Container>
                <Row>
                    <Col>
                        <h4>Informações extra</h4>
                    </Col>
                </Row>
                <Row>
                    <Col lg={3}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="bloodType">Tipo sanguíneo</Form.Label>
                            <Form.Select
                                aria-label="Tipo sanguíneo"
                                defaultValue={form.bloodType}
                                id="bloodType"
                                name="bloodType"
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="bloodTypeHelpBlock"
                                required
                            >
                                <option key="-1">Selecione</option>
                                {bloodTypes.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                            </Form.Select>
                            <Form.Text id="bloodTypeHelpBlock" muted>
                                Defina a qual é o tipo sanguíneo
                            </Form.Text>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="allergies">Alergias</Form.Label>
                            <Form.Control
                                as={'textarea'}
                                id="allergies"
                                name="allergies"
                                value={form.allergies || ''}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="allergiesHelpBlock"
                            />
                            <Form.Text id="allergiesHelpBlock" muted>
                                Informe alergias
                            </Form.Text>
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="treatmentInProgress">Tratamentos em andamento</Form.Label>
                            <Form.Control
                                as={'textarea'}
                                id="treatmentInProgress"
                                name="treatmentInProgress"
                                value={form.treatmentInProgress || ''}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="treatmentInProgressHelpBlock"
                            />
                            <Form.Text id="treatmentInProgressHelpBlock" muted>
                                Informe tratamentos em andamento
                            </Form.Text>
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="form mt-2">
                            <Form.Label htmlFor="medications">Medicamentos</Form.Label>
                            <Form.Control
                                as={'textarea'}
                                id="medications"
                                name="medications"
                                value={form.medications || ''}
                                onChange={(e) => handleChange(e, component)}
                                aria-describedby="medicationsHelpBlock"
                            />
                            <Form.Text id="medicationsHelpBlock" muted>
                                Informe medicamentos
                            </Form.Text>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    };
}

export default ExtraTabStudentForm;